import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { useI18n } from "@/i18n";
import Navbar from "@/components/Navbar";
import { Bookmark } from "lucide-react";

export default function Bookmarks() {
  const { t, lang } = useI18n();
  const [items, setItems] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    api.get(`/bookmarks?lang=${lang}`).then((r) => { setItems(r.data); setLoaded(true); }).catch(() => setLoaded(true));
  }, [lang]);

  return (
    <div className="min-h-screen bg-void">
      <Navbar />
      <main className="pt-28 pb-16 max-w-3xl mx-auto px-6" data-testid="bookmarks-page">
        <h1 className="font-serif text-5xl text-ink mb-10 flex items-center gap-3">
          <Bookmark className="text-gold" strokeWidth={1.5} /> {t("bookmarks.title")}
        </h1>
        {loaded && items.length === 0 ? (
          <p className="text-ink-muted" data-testid="bookmarks-none">{t("bookmarks.none")}</p>
        ) : (
          <div className="divide-y divide-ink/5 border-t border-ink/5">
            {items.map((b) => (
              <Link key={b.lesson_id} to={`/lesson/${b.lesson_id}`}
                className="group flex items-baseline justify-between py-4 hover:pl-2 transition-all"
                data-testid={`bookmark-${b.lesson_id}`}>
                <span className="text-lg text-ink group-hover:text-gold transition-colors">{b.title}</span>
                <span className="text-xs text-ink-muted">{b.module_title}</span>
              </Link>
            ))}
          </div>
        )}
      </main>
    </div>
  );
}
